import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logoutUser } from '../../actions/authActions';
import './vitals.css';

const WITALS_FAVICON =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
    '<circle cx="16" cy="16" r="16" fill="%23e14b4b"/>' +
    '<text x="16" y="22" font-size="18" text-anchor="middle" fill="white">♥</text>' +
    '</svg>'
  );

function VitalsNav({ logoutUser, fixed }) {
  useEffect(() => {
    document.title = 'Witals24';
    let link = document.querySelector("link[rel='icon']") || document.querySelector("link[rel='shortcut icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = WITALS_FAVICON;
  }, []);

  return (
    <header className={`vitals-nav${fixed ? ' vitals-nav-fixed' : ''}`}>
      <div className="vitals-nav-brand">
        <span className="vitals-nav-logo">♥</span>
        Witals24
      </div>
      <nav className="vitals-nav-links">
        <Link to="/witals">Live Monitoring</Link>
      </nav>
      <button
        type="button"
        className="vitals-nav-logout"
        onClick={() => { logoutUser(); window.location.href = '/login'; }}
      >
        Log out
      </button>
    </header>
  );
}

export default connect(null, { logoutUser })(VitalsNav);
